import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarsSort } from '@fortawesome/pro-light-svg-icons';
import { getSortingIcon } from '@/domain/arbeitszeiten/shared/util/utils';

export const SortableHeader = ({
  title,
  sorted,
}: {
  title: string;
  sorted: 'asc' | 'desc' | false;
}) => (
  <div className="flex flex-row gap-2 items-center cursor-pointer">
    <span>{title ? title : <FontAwesomeIcon icon={faBarsSort} />}</span>
    {getSortingIcon(sorted)}
  </div>
);
